import Dashboard from "../Components/Dashboard/Dashboard";
import TableauComponent from "../Components/TableauView/TableauComponent";
import BlankPage from "../Components/BlankPage/BlankPage";
import DocumentViewer from "../Components/DocumentsPage/DocumentViewer";
import Documents from "../Components/DocumentsPage/Documents";
import AdminPage from "../Components/Admin/AdminPage";
import Template from "../Components/Template/Template";
import Report from "../Components/Report/Report";
import CriteriaManagement from '../Components/CriteriaManagement/CriteriaManagement';
import EditMinimumProviders from '../Components/CriteriaManagement/EditMinimumProviders';
import EditHierarchy from "../Components/CriteriaManagement/EditHierarchy";
import Upload from "../Components/Template/Upload";
import Uploadhistory from "../Components/Template/Uploadhistory";
import DataPage from "../Components/Data/DataPage";
import UploadedFiles from "../Components/Data/UploadedFiles";
import DashboardPage from "../Components/Dashboard/DashboardPage";

const routes = [
  {
    feature: "DASHBOARDS",
    path: "/dashboard",
    component: DashboardPage,
    children: [
      {
        path: "dashboard",
        component: Dashboard,
      },
      {
        path: "documents",
        component: DocumentViewer,
      },
      {
        path: "documents/:documentId", // Add route for specific document
        component: DocumentViewer,
      },
      {
        path: "",  // default route
        component: Dashboard,
      }
    ]
  },
  {
    feature: "DASHBOARDS",
    path: "/dashboard/:id",
    component: TableauComponent,
  },
  {
    feature: "DATA_UPLOAD",
    path: "/dataupload",
    component: Template,
    children: [
      {
        path: "upload",
        component: Upload,
      },
      {
        path: "uploadhistory",
        component: Uploadhistory,
      },
      {
        path: "",  // default route
        component: Upload,
      }
    ]
  },
  {
    feature: "REPORT",
    path: "/report",
    component: Report,
    children: [
      {
        path: "report",
        component: BlankPage,
      },
      {
        path: "",  // default route
        component: BlankPage,
      }
    ]
  },
  {
    feature: "DATA",
    path: "/data",
    component: DataPage,
    children: [
      {
        path: "files",
        component: UploadedFiles,
      },
      {
        path: "",  // default route
        component: UploadedFiles,
      }
    ]
  },
  {
    feature: "ADMIN",
    path: "/admin",
    component: AdminPage,
    children: [
      {
        path: "platform",
        component: BlankPage,
      },
      {
        path: "users",
        component: BlankPage,
      },
      {
        path: "",  // default route
        component: BlankPage,
      }
    ]
  },
  {
    feature: "CRITERIA_MANAGEMENT",
    path: "/criteriamanagement",
    component: CriteriaManagement,
  },
  {
    feature: "EDIT_MINIMUM_PROVIDERS",
    path: "/criteriamanagement/editminimumproviders",
	component: EditMinimumProviders,
  },
  {
    feature: "EDIT_HIERARCHY",
    path: "/criteriamanagement/edithierarchy",
	component: EditHierarchy,
  },
];

export default routes;
